export default __webpack_public_path__ + "static/media/asset3.b377a3de.png";